/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

export const commonTranslations = {
    active: "ACTIVE",
    allCapsDelete: "DELETE",
    analyses: "Analyses",
    analysisApplication: "Analysis Application",
    analysisMetric: "Analysis Metric",
    application: "Application",
    archived: "ARCHIVED",
    attributes: "Summary Metrics",
    barcodeUuid: "Barcode UUID",
    barcodeType: "Barcode Type",
    barcodedSamples: "Barcoded Samples",
    bioSampleName: "Bio Sample Name",
    cancel: "Cancel",
    cellId: "Cell ID",
    cellIndex: "Cell Index",
    collections: "Collections",
    comments: "Comments",
    completedAt: "Completion Date",
    completedOn: "Completed On",
    copy: "Copy",
    createDataSet: "Create Dataset",
    createProject: "Create Project",
    created: "CREATED",
    createdAt: "Date Created",
    createdBy: "Created By",
    data: "Data",
    dataManagement: "Data Management",
    dataSetName: "Dataset Name",
    dataset: "Dataset",
    datasets: "Datasets",
    delete: "Delete",
    description: "Description",
    displayAll: "Display All",
    dnaBarcodeName: "Barcode Name",
    edit: "Edit",
    entryPoints: "Entry Points",
    error: "Error: {errorMessage}",
    errorMessage: "Error Message",
    export: "Export",
    file: "File",
    fileDownloads: "File Downloads",
    fileSize: "File Size",
    home: "Home",
    id: "Id",
    import: "Import",
    importSequenceData: "Import Sequence Data",
    importedAt: "Date Imported",
    inputs: "Inputs",
    instrumentName: "Instrument Name",
    instrumentSerialNumber: "Instrument SN",
    instrumentSwVersion: "Instrument SW",
    jobId: "Job Id",
    jobTypeId: "Job Type Id",
    killed: "KILLED",
    loadingEvaluation: "Loading Evaluation",
    md5: "MD5",
    mean: "Mean",
    metadataContextId: "Movie Name",
    name: "Name",
    newRunDesign: "New Run Design",
    noLogAvailable: "No log available",
    numCellsCompleted: "Completed Cells",
    numCellsFailed: "Failed Cells",
    numChildren: "Demultiplexed Subsets",
    numRecords: "Number of Records",
    numSequences: "Number of Sequences",
    numSubreads: "Number of Subreads",
    numBarcodes: "Number of Barcodes",
    numTargets: "Number of Targets",
    off: "Off",
    ok: "Ok",
    on: "On",
    operator: "Operator",
    options: "Pipeline Options",
    organism: "Organism",
    path: "Path",
    pipelineId: "Pipeline Id",
    plateId: "Plate Id",
    ploidy: "Haploid/Diploid",
    preAnalysis: "Pre-analysis",
    primaryAnalysisSwVersion: "Primary Analysis SW",
    projectId: "Project Id",
    reserved: "Reserved",
    runDate: "Run Date",
    runId: "Run Id",
    runMultiJobId: "Multi-analysis ID",
    runName: "Run Name",
    runUuid: "Run UUID",
    running: "RUNNING",
    sampleName: "Sample Name",
    sampleUuid: "Sample UUID",
    save: "Save",
    size: "Size",
    smrtLinkLog: "SMRT Link Log",
    smrtlinkVersion: "SMRT Link Version",
    sortValue: "Sort Value",
    state: "State",
    status: "Status",
    successful: "SUCCESSFUL",
    summary: "Summary",
    tags: "Tags",
    taskOptions: "Task Options",
    templateId: "Pipeline",
    thumbnails: "Thumbnails",
    title: "Title",
    totalCells: "Total Cells",
    totalLength: "Total Length (bp)",
    totalLengthUnitless: "Total Length",
    totalLengthSubreads: "Total Length of Subreads (bp)",
    transfersCompletedAt: "Transferred Date",
    type: "Type",
    updatedAt: "Date Updated",
    uuid: "UUID",
    value: "Value",
    version: "Version",
    view: "View",
    viewProjects: "View Projects",
    wellName: "Well Name",
    wellSampleName: "Well Sample Name"
}
